import './App.css';
import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Home from './pages/home.js';
import About from './pages/about.js';
import Services from './pages/services.js';
import Contact from './pages/contactUs.js';
import Gallery from './pages/gallery.js';
function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home/>} />
        <Route path="/aboutUs" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contactUs" element={<Contact />} />
        <Route path="/gallery" element={<Gallery />} />
      </Routes>
    </div>
  );
}

export default App;
